import { render, staticRenderFns } from "./ReturnOrderOriginWarehouseId.vue?vue&type=template&id=237b0d94&"
import script from "./ReturnOrderOriginWarehouseId.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderOriginWarehouseId.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderOriginWarehouseId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports